/* @jsxImportSource react */
/**
 * In the case of an error, this component explicitly shown nothing.
 * because we want to handle errors gracefully and avoid
 * showing broken or incomplete content to the user.
 *
 * if this requirement should change,
 * the behavior can be changed centrally here,
 * e.g. to output a placeholder component with a basic layout.
 *
 * @returns {null}
 */
export const FooterFallbackError = (): null => null;
